// Slice RTK per `state.search` (string).
// Setter pubblicato come `setLastSearch` per back-compat con il vecchio action
// `SET_SEARCH`. Vedi cdiFiltersSlice.js per il pattern.

import { createSlice } from '@reduxjs/toolkit';

const initialState = '';

const searchSlice = createSlice({
  name: 'search',
  initialState,
  reducers: {
    set: (_state, action) => action.payload ?? '',
    clear: () => initialState,
  },
});

// Esportato come `setLastSearch` per mantenere la firma esterna.
export const { set: setLastSearch, clear: clearSearch } = searchSlice.actions;

export default searchSlice.reducer;
